import { Helmet } from 'react-helmet';
import { BOOKING_SLUG } from '../api/constants';
import { getDoctorSelectorList } from '../store/idbHandler';
import LeftBar from '../components/common/NavBar';
import React, { useState } from 'react';
import AppLoader from '../components/common/AppLoader';
import DoctorFilterStripUi from '../components/multiDocComponents/DoctorStrip';

export const CURIO_IFRAME_ID = 'dr-eka-care';

const MyCalendar: React.FC = () => {
    const doctors = getDoctorSelectorList();

    const [selectedUserName, setSelectedUsername] = React.useState(
        () => doctors?.[0].professional.username,
    );

    if (!selectedUserName) {
        return null;
    }

    const doctorsLength = doctors?.length || 0;

    const [isLoading, setLoader] = useState(true);

    return (
        <div className="flex flex-col w-screen h-full bg-white font-lato select-none">
            <Helmet>
                <meta charSet="utf-8" />
                <title>EKA - My Calendar</title>
            </Helmet>

            <div className="grid grid-cols-queueGrid h-full min-w-840 overflow-x-auto">
                <LeftBar />

                <div className="flex flex-col col-span-11 pt-16 space-y-24 overflow-hidden mb-30">
                    {isLoading && (
                        <div className="flex flex-1 flex-auto w-full h-full items-center justify-center">
                            <AppLoader />
                        </div>
                    )}

                    <div
                        style={
                            isLoading ? { width: 0, height: 0 } : { width: '100%', height: '100%' }
                        }
                    >
                        <div className="flex space-x-4 overflow-x-scroll w-full">
                            {doctorsLength > 1
                                ? doctors?.map((doc) => (
                                      <DoctorFilterStripUi
                                          key={doc.id}
                                          doctorName={`Dr. ${doc.personal.name.f || ''} ${
                                              doc.personal.name.l || ''
                                          }`.trim()}
                                          doctorPic={doc.personal.pic}
                                          onClick={() => {
                                              setSelectedUsername(doc.professional.username);
                                          }}
                                          showAptCount={false}
                                          isSelected={
                                              selectedUserName === doc.professional.username
                                          }
                                      />
                                  ))
                                : null}
                        </div>
                        <iframe
                            id={CURIO_IFRAME_ID}
                            referrerPolicy="strict-origin"
                            onLoad={() => setLoader(false)}
                            className="w-full"
                            style={{ height: '90%' }}
                            src={`${BOOKING_SLUG}/doctor/${selectedUserName}/manage-calendar`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyCalendar;
